import ExpandableTable, { ExpandChevron } from "../ui/ExpandableTable";
import { visibleGroups } from "./columns";

function periodLabel(iso) {
  const start = new Date(`${iso}T00:00:00`);
  const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);
  const opts = { day: "numeric", month: "short" };
  return `${start.toLocaleDateString("en-GB", opts)} – ${end.toLocaleDateString("en-GB", opts)}`;
}

/**
 * A collection page and an unreadable destination are not products, and a
 * reader who takes them for one will misread the conversion rate — a collection
 * page converts differently by nature. Badge them rather than hide them: their
 * spend is real, and the column only reconciles to the ad account because they
 * are here.
 */
function KindBadge({ kind }) {
  if (kind === "product") return null;
  const label = kind === "unresolved" ? "no destination" : "page";
  return (
    <span className="ml-2 px-1.5 py-0.5 text-[9px] uppercase tracking-widest border border-solid border-current align-middle">
      {label}
    </span>
  );
}

export default function ProductsTable({ rows, expansion, hidden }) {
  function renderCell(col, row, { open, isChild }) {
    if (col.key !== "label") return col.render(row);
    if (isChild) {
      return (
        <span className="pl-6 inline-block text-collectors-gray">
          {periodLabel(row.period)}
        </span>
      );
    }
    return (
      <span className="flex items-center gap-2">
        <ExpandChevron open={open} />
        <span className="truncate max-w-[280px]">{row.label}</span>
        <KindBadge kind={row.kind} />
      </span>
    );
  }

  function rowClassName(row, { isChild, col }) {
    if (col.key !== "spend" || isChild) return "";
    // Spend is the sort key and the reason a row is where it is.
    return "font-bold";
  }

  return (
    <ExpandableTable
      groups={visibleGroups(hidden)}
      rows={rows}
      rowKey={(row) => row.key}
      renderCell={renderCell}
      rowClassName={rowClassName}
      expansion={expansion}
      emptyLabel="No products with traffic or spend in this time range."
      childEmptyLabel="No weeks with data for this product."
    />
  );
}
